<template>
<div>
  <el-table element-loading-text="加载中，请耐心等待。" :data="tbdata1"
            border style="width: 100%" highlight-current-row ref="single">
    <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
    <el-table-column label="服务内容" min-width="110" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.is_service === 1">{{scope.row.typename}}</span>
      </template>
    </el-table-column>
    <el-table-column label="所属服务类型" min-width="90" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.is_service === 0">{{scope.row.typename}}</span>
        <span v-else>{{getUpTypeName(scope.row.upid)}}</span>
      </template>
    </el-table-column>
    <el-table-column v-if="moduletag !== 2" label="所属组织" min-width="100" align="center">
      <template slot-scope="scope">
        <span>{{getOnOrg(scope.row)}}</span>
      </template>
    </el-table-column>
    <el-table-column v-if="moduletag !== 2" prop="createtime" label="录入时间" min-width="90" align="center"></el-table-column>
    <el-table-column align="center" label="操作" width="90">
      <template slot-scope="scope">
        <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editServiceType(scope.row)"></i>
        <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delServiceType(scope.row)"></i>
      </template>
    </el-table-column>
  </el-table>
</div>
</template>
<script>
export default {
  name: 'tableData1',
  props: {
    tbdata1: {
      type: Array,
      default: null
    },
    tableData: {
      type: Array,
      default: null
    },
    orgData: {
      type: Array,
      default: null
    },
    moduletag: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    editServiceType (row) {
      let obj = {
        isEdit: true,
        row: row
      }
      this.$emit('getFatherChange', obj)
    },
    delServiceType (row) {
      let obj = {
        isEdit: false,
        row: row
      }
      this.$emit('getFatherChange', obj)
    },
    getUpTypeName (upid) {
      let name = ''
      let upids = this.getOrgName1(parseInt(upid), [])
      for (let i = 0; i < upids.length; i++) {
        for (let j = 0; j < this.tableData.length; j++) {
          if (parseInt(upids[i]) === this.tableData[j].id) {
            name = this.tableData[j].typename + ' / ' + name
          }
        }
      }
      return name !== '' ? name.substring(0, name.length - 3) : ''
    },
    getOrgName1 (upid, arr) {
      arr.push(upid)
      for (let i = 0; i < this.tableData.length; i++) {
        if (parseInt(upid) === this.tableData[i].id) {
          arr = this.getOrgName1(this.tableData[i].upid, arr)
        }
      }
      return arr
    },
    getOnOrg (row) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (row.orgid === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/childComponents/tableData1.vue